import { render, staticRenderFns } from "./StoreOnlyList.vue?vue&type=template&id=8b8c99a0&scoped=true"
import script from "./StoreOnlyList.vue?vue&type=script&lang=js"
export * from "./StoreOnlyList.vue?vue&type=script&lang=js"
import style0 from "./StoreOnlyList.vue?vue&type=style&index=0&id=8b8c99a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8c99a0",
  null
  
)

export default component.exports